import { useLazyQuery } from "@apollo/client";
import { useMemo } from "react";
import {
  ClientFindBookingScheduleDocument,
  PackageRecurrenceEnum,
  type ClientFindBookingScheduleQuery,
  type ClientFindBookingScheduleQueryVariables,
} from "@/__generated__/graphql";
import {
  groupTimeSlotByDate,
  transformScheduleVariantToTimeSlot,
} from "@/lib/booking-lib";
import type { TimeSlot } from "@/types/booking";
import { useBookingState } from "@/store/booking/useBookingState";

export const useClientFindBookingScheduleQuery = () => {
  const [execute, { loading, error, data }] = useLazyQuery<
    ClientFindBookingScheduleQuery,
    ClientFindBookingScheduleQueryVariables
  >(ClientFindBookingScheduleDocument, {
    fetchPolicy: "network-only",
  });

  const transformedData = useMemo((): Record<string, TimeSlot[]> | null => {
    if (!data) return null;

    const [frequency] = useBookingState.getState().data.packageDetailsFilter
      .repeatEvery ?? [PackageRecurrenceEnum.AdHoc];

    return groupTimeSlotByDate(
      transformScheduleVariantToTimeSlot(
        data.clientFindBookingSchedule,
        frequency !== PackageRecurrenceEnum.AdHoc,
      ),
    );
  }, [data]);

  return {
    execute,
    loading,
    error,
    data,
    transformedData,
  };
};
